import React, { useState } from 'react';
import Modal from 'react-modal';
import MenuItem from './MenuItem';
import ItemDetailModal from './ItemDetailModal';

// Set the app element for react-modal accessibility (should ideally be in your main App file)
Modal.setAppElement('#root');

const MenuItems = ({ categories, selectedCategory, language }) => {
  // State to keep track of the selected item
  const [selectedItem, setSelectedItem] = useState(null);

  // Find the selected category
  const category = categories.find(cat => cat.id === selectedCategory);

  if (!category) return <div className="no-items">No category selected</div>;

  // Handler to set the selected item when a MenuItem is clicked
  const handleItemClick = (item) => {
    setSelectedItem(item);
  };

  return (
    <div className="menu-items-container">
      {category.items && category.items.length > 0 ? (
        <div className="menu-items-list">
          {category.items.map(item => (
            <MenuItem
              key={item.id}
              item={item}
              language={language}
              onItemClick={handleItemClick} // Pass the click handler to MenuItem
            />
          ))}
        </div>
      ) : (
        <div className="no-items">
          {language === 'en' ? 'No items available in this category' :
           language === 'ar' ? 'لا توجد عناصر متاحة في هذه الفئة' :
           'هیچ خواردنێک لەم بەشەدا بەردەست نییە'}
        </div>
      )}
      {/* Render the modal when an item is selected */}
      {selectedItem && (
        <Modal
          isOpen={!!selectedItem} // Modal is open if selectedItem is not null
          onRequestClose={() => setSelectedItem(null)} // Close modal when clicking outside
          style={{
            overlay: {
              backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent overlay
            },
            content: {
             backgroundColor:"#F9F6ED",
             color:"#5C0E11",
              border: 'none',
              borderRadius: '10px',
              padding: '20px',
              maxWidth: '300px',
              maxHeight : '400px',
              margin: 'auto', // Center the modal horizontally
            },
          }}
        >
          <ItemDetailModal
            item={selectedItem}
            onClose={() => setSelectedItem(null)} // Pass close function to ItemDetailModal
            language={language}
          />
        </Modal>
      )}
    </div>
  );
};

export default MenuItems;